import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';

export default function SignupPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('Password must be at least 6 characters'); return; }
    setLoading(true);
    const result = await register(name, email, password);
    setLoading(false);
    if (result.success) navigate('/dashboard');
    else setError(result.error);
  };

  return (
    <div className="min-h-screen flex" data-testid="signup-page">
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1772249491071-56be1b1b3e7a?w=1200&q=80" alt="Architecture" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#1a365d]/70" />
        <div className="relative z-10 flex flex-col justify-end p-12 text-white">
          <h2 className="font-['Outfit'] text-4xl font-semibold tracking-tight mb-3">Leela Solutions</h2>
          <p className="text-white/80 text-lg">Professional Door & Window Quotation System</p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6 sm:p-12 bg-slate-50">
        <div className="w-full max-w-md">
          <div className="mb-8">
            <div className="flex items-center gap-2 mb-6 lg:hidden">
              <img src="/logo.png" alt="Leela Solutions" className="w-10 h-10 rounded-lg object-contain" />
              <span className="font-['Outfit'] font-semibold text-xl text-[#1a365d]">Leela Solutions</span>
            </div>
            <h1 className="font-['Outfit'] text-3xl font-semibold tracking-tight text-slate-900">Create account</h1>
            <p className="text-slate-500 mt-1">Get started with Leela Solutions</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            {error && <div className="bg-red-50 text-red-600 text-sm px-4 py-3 rounded-lg border border-red-200" data-testid="signup-error">{error}</div>}
            <div className="space-y-2">
              <Label htmlFor="name">Full Name</Label>
              <Input id="name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" required data-testid="signup-name-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" required data-testid="signup-email-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Min 6 characters" required data-testid="signup-password-input" />
            </div>
            <Button type="submit" className="w-full bg-[#ed8936] hover:bg-[#dd6b20] text-white" disabled={loading} data-testid="signup-submit-btn">
              {loading ? 'Creating account...' : 'Create Account'}
            </Button>
          </form>

          <p className="text-center text-sm text-slate-500 mt-6">
            Already have an account? <Link to="/login" className="text-[#ed8936] hover:text-[#dd6b20] font-medium" data-testid="goto-login-link">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
